import { Pipe, PipeTransform } from '@angular/core';
import { defineConstants } from '@root/util/defineConstants';
import { TranslateService } from '../service/translate.service';

const { VK } = defineConstants(
  [
    { value: 'id_card', key: 'guest.list.id_card' },
    { value: 'passport', key: 'guest.list.passport' },
    { value: 'gang_ao_tai_card', key: 'guest.list.exit_entry_permit' },
    { value: 'serviceman_card', key: 'guest.list.military_id' },
  ] as const,
  ''
);

/**
 * 用于获取证件类型
 */
@Pipe({
  name: 'credential',
})
export class CredentialPipe implements PipeTransform {
  constructor(private t: TranslateService) {}
  transform(value: any, args?: any): any {
    return this.t.t(VK[value]);
  }
}
